export const commonStyles = {
    overlay: {
        position: 'absolute',
        background: 'rgba(18, 18, 18, 0.9)',
        color: '#F5F5F0',
        borderRadius: '8px',
        pointerEvents: 'none',
        zIndex: 10,
    },
    text: {
        fontFamily: 'monospace',
        color: '#F5F5F0',
    },
    button: {
        background: '#F5F5F0',
        border: 'none',
        borderRadius: '4px',
        padding: '0.5rem 1rem',
        color: '#121212',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
            background: '#FFFFFF',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }
    }
};

export const animations = {
    fadeInOut: `
        @keyframes fadeInOut {
            0%, 100% { opacity: 0.4; }
            50% { opacity: 0.8; }
        }
    `
}; 